// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "../../../../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Belt_Array from "../../../../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as AllocationDashboardUtils from "../../../../utils/AllocationDashboardUtils.bs.js";
import * as TooltipComponent$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/tooltip/TooltipComponent.bs.js";
import * as AllocationCampaignFooterCmp from "../../reusable-components/AllocationCampaignFooterCmp.bs.js";
import * as AllocationDashboardAssetsManager from "../../../../../assets/AllocationDashboardAssetsManager.bs.js";
import * as ZonalOrClusterCampaignPreviewVMMapper from "../../../../../view-model/zonal-cluster-campaigns-preview/ZonalOrClusterCampaignPreviewVMMapper.bs.js";

var arrowDropDownRedIcon = AllocationDashboardAssetsManager.getImage("red-arrow-drop-down.svg");

var arrowDropDownGreenIcon = AllocationDashboardAssetsManager.getImage("green-arrow-drop-down.svg");

var infoIcon = AllocationDashboardAssetsManager.getImage("info-icon.svg");

function PreviewZonalOrClusterCampaignCmp$RenderArrowAndDeltaDetailsIcon(Props) {
  var left_value = Props.left_value;
  var right_value = Props.right_value;
  return React.createElement(React.Fragment, undefined, AllocationDashboardUtils.PreviewZonalOrClusterCampaigns.getDeltaValue(left_value, right_value) !== 0.0 ? React.createElement(React.Fragment, undefined, AllocationDashboardUtils.PreviewZonalOrClusterCampaigns.getDeltaValue(left_value, right_value) > 0.0 ? React.createElement("img", {
                          src: arrowDropDownGreenIcon
                        }) : React.createElement("img", {
                          src: arrowDropDownRedIcon
                        }), React.createElement("p", {
                        className: "ald-zonal-cluster-delta-values " + (
                          AllocationDashboardUtils.PreviewZonalOrClusterCampaigns.getDeltaValue(left_value, right_value) > 0.0 ? "ald-zonal-cluster-delta-positive" : "ald-zonal-cluster-delta-negative"
                        )
                      }, String(AllocationDashboardUtils.PreviewZonalOrClusterCampaigns.toFixedDecimalPoint(AllocationDashboardUtils.PreviewZonalOrClusterCampaigns.getDeltaValue(left_value, right_value), 2)))) : null);
}

var RenderArrowAndDeltaDetailsIcon = {
  make: PreviewZonalOrClusterCampaignCmp$RenderArrowAndDeltaDetailsIcon
};

function PreviewZonalOrClusterCampaignCmp$GetCreatorInfo(Props) {
  var created_by = Props.created_by;
  var created_on = Props.created_on;
  var status = Props.status;
  var tmp;
  if (status !== undefined) {
    var getStyleClass;
    switch (status) {
      case "ACTIVE" :
          getStyleClass = "ald-active-campaign";
          break;
      case "PENDING" :
          getStyleClass = "ald-pending-campaign";
          break;
      case "SCHEDULED" :
          getStyleClass = "ald-scheduled-campaign";
          break;
      default:
        getStyleClass = "";
    }
    tmp = React.createElement("div", {
          className: "section-row"
        }, React.createElement("p", {
              className: "status"
            }, "Status"), React.createElement("p", {
              className: getStyleClass
            }, status));
  } else {
    tmp = null;
  }
  return React.createElement(React.Fragment, undefined, tmp, React.createElement("div", {
                  className: "section-row"
                }, React.createElement("p", undefined, "Created By"), React.createElement("p", undefined, created_by)), React.createElement("div", {
                  className: "section-row"
                }, React.createElement("p", undefined, "Created On"), React.createElement("p", undefined, created_on)));
}

var GetCreatorInfo = {
  make: PreviewZonalOrClusterCampaignCmp$GetCreatorInfo
};

function PreviewZonalOrClusterCampaignCmp$DisplaySection(Props) {
  var heading = Props.heading;
  var renderProps = Props.renderProps;
  return React.createElement("div", {
              className: "section-row"
            }, React.createElement("p", undefined, heading), Curry._1(renderProps, undefined));
}

var DisplaySection = {
  make: PreviewZonalOrClusterCampaignCmp$DisplaySection
};

function PreviewZonalOrClusterCampaignCmp$DisplayDateAndTimeSection(Props) {
  var keySection = Props.keySection;
  var value = Props.value;
  var unit = Props.unit;
  return React.createElement("div", {
              className: "section-row"
            }, React.createElement("p", undefined, keySection, React.createElement("label", {
                      className: "unit"
                    }, unit)), React.createElement("p", undefined, value));
}

var DisplayDateAndTimeSection = {
  make: PreviewZonalOrClusterCampaignCmp$DisplayDateAndTimeSection
};

function PreviewZonalOrClusterCampaignCmp$GetTimingDateAndActiveDaysInfo(Props) {
  var _type = Props.type;
  var startDate = Props.startDate;
  var startTime = Props.startTime;
  var endTime = Props.endTime;
  var endDate = Props.endDate;
  var days = Props.days;
  return React.createElement(React.Fragment, undefined, React.createElement(PreviewZonalOrClusterCampaignCmp$DisplaySection, {
                  heading: "Type",
                  renderProps: (function (param) {
                      return React.createElement("p", undefined, _type);
                    })
                }), React.createElement(PreviewZonalOrClusterCampaignCmp$DisplayDateAndTimeSection, {
                  keySection: "Start Date ",
                  value: startDate,
                  unit: "(DD/MM/YYYY)"
                }), React.createElement(PreviewZonalOrClusterCampaignCmp$DisplayDateAndTimeSection, {
                  keySection: "Start Time ",
                  value: startTime,
                  unit: "(HH:MM)"
                }), React.createElement(PreviewZonalOrClusterCampaignCmp$DisplayDateAndTimeSection, {
                  keySection: "End Time ",
                  value: endTime,
                  unit: "(HH:MM)"
                }), React.createElement(PreviewZonalOrClusterCampaignCmp$DisplayDateAndTimeSection, {
                  keySection: "End Date - Campaign ",
                  value: endDate,
                  unit: "(DD/MM/YYYY)"
                }), React.createElement(PreviewZonalOrClusterCampaignCmp$DisplaySection, {
                  heading: "Active Days",
                  renderProps: (function (param) {
                      return React.createElement("p", undefined, days);
                    })
                }));
}

var GetTimingDateAndActiveDaysInfo = {
  make: PreviewZonalOrClusterCampaignCmp$GetTimingDateAndActiveDaysInfo
};

function PreviewZonalOrClusterCampaignCmp$GetSegmentNames(Props) {
  var validations = Props.validations;
  return React.createElement(React.Fragment, undefined, React.createElement(PreviewZonalOrClusterCampaignCmp$DisplaySection, {
                  heading: "Validation Type",
                  renderProps: (function (param) {
                      return React.createElement("p", undefined, Belt_List.toArray(Belt_List.map(validations, (function (param) {
                                            return React.createElement("p", undefined, param[0]);
                                          }))));
                    })
                }), React.createElement(PreviewZonalOrClusterCampaignCmp$DisplaySection, {
                  heading: "Segment Names",
                  renderProps: (function (param) {
                      var segmentNamesStr = Belt_List.toArray(Belt_List.concatMany(Belt_List.toArray(Belt_List.map(validations, (function (param) {
                                            return param[1];
                                          }))))).join(", ");
                      return React.createElement("p", {
                                  className: "ald-zonal-cluster-segment-names"
                                }, segmentNamesStr);
                    })
                }));
}

var GetSegmentNames = {
  make: PreviewZonalOrClusterCampaignCmp$GetSegmentNames
};

function PreviewZonalOrClusterCampaignCmp$GetListOfZones(Props) {
  var preview_data = Props.preview_data;
  var tool_tip = preview_data.zones.tool_tip_content;
  return React.createElement(React.Fragment, undefined, React.createElement("p", undefined, tool_tip !== undefined ? React.createElement("div", {
                        className: "ald-cluster-zone-tool-tip"
                      }, React.createElement("div", undefined, preview_data.zones.content), React.createElement(TooltipComponent$Catalyst.make, {
                            content: tool_tip.content,
                            placement: /* Top_End */10,
                            children: React.createElement("div", {
                                  className: "popper"
                                }, tool_tip.title)
                          })) : React.createElement("div", undefined, preview_data.zones.content)));
}

var GetListOfZones = {
  make: PreviewZonalOrClusterCampaignCmp$GetListOfZones
};

function PreviewZonalOrClusterCampaignCmp$GetListOfZonesOrClusters(Props) {
  var preview_data = Props.preview_data;
  var match = preview_data.clusters.content;
  if (match === "Not Applicable") {
    return React.createElement(PreviewZonalOrClusterCampaignCmp$DisplaySection, {
                heading: "List of Zones",
                renderProps: (function (param) {
                    return React.createElement(PreviewZonalOrClusterCampaignCmp$GetListOfZones, {
                                preview_data: preview_data
                              });
                  })
              });
  } else {
    return React.createElement(React.Fragment, undefined, React.createElement(PreviewZonalOrClusterCampaignCmp$DisplaySection, {
                    heading: "Zones",
                    renderProps: (function (param) {
                        return React.createElement(PreviewZonalOrClusterCampaignCmp$GetListOfZones, {
                                    preview_data: preview_data
                                  });
                      })
                  }), React.createElement(PreviewZonalOrClusterCampaignCmp$DisplaySection, {
                    heading: "List of Clusters",
                    renderProps: (function (param) {
                        var tool_tip = preview_data.clusters.tool_tip_content;
                        return React.createElement("p", undefined, tool_tip !== undefined ? React.createElement("div", {
                                          className: "ald-cluster-zone-tool-tip"
                                        }, React.createElement("div", undefined, preview_data.clusters.content), React.createElement(TooltipComponent$Catalyst.make, {
                                              content: tool_tip.content,
                                              placement: /* Top_End */10,
                                              children: React.createElement("div", {
                                                    className: "popper"
                                                  }, tool_tip.title)
                                            })) : React.createElement("div", undefined, preview_data.clusters.content));
                      })
                  }));
  }
}

var GetListOfZonesOrClusters = {
  make: PreviewZonalOrClusterCampaignCmp$GetListOfZonesOrClusters
};

function PreviewZonalOrClusterCampaignCmp$GetFilterType(Props) {
  var subType = Props.subType;
  var infoIconDescription = Props.infoIconDescription;
  var left_value = Props.left_value;
  var right_value = Props.right_value;
  var radius_delta = Props.radius_delta;
  var active_mandatory_campaign = Props.active_mandatory_campaign;
  switch (subType) {
    case "Allocation Radius" :
        return React.createElement(React.Fragment, undefined, React.createElement("div", {
                        className: "section-row"
                      }, React.createElement("p", {
                            className: ""
                          }, subType, React.createElement(TooltipComponent$Catalyst.make, {
                                content: infoIconDescription,
                                placement: /* Top_End */10,
                                children: React.createElement("img", {
                                      className: "ald-zonal-cluster-item-info-icon-img",
                                      src: infoIcon
                                    })
                              }))), React.createElement("div", {
                        className: "section-row"
                      }, React.createElement("p", {
                            className: "ald-zone-cluster-filter-type"
                          }, "Auto"), React.createElement("p", {
                            className: "ald-zone-cluster-filter-type-value"
                          }, String(left_value) + " KMS")), React.createElement("div", {
                        className: "section-row-delta-value"
                      }, React.createElement(PreviewZonalOrClusterCampaignCmp$RenderArrowAndDeltaDetailsIcon, {
                            left_value: left_value,
                            right_value: active_mandatory_campaign.filters.allocation_radius.auto
                          })), React.createElement("div", {
                        className: "section-row"
                      }, React.createElement("p", {
                            className: "ald-zone-cluster-filter-type"
                          }, "Manual"), React.createElement("p", {
                            className: "ald-zone-cluster-filter-type-value"
                          }, String(right_value) + " KMS")), React.createElement("div", {
                        className: "section-row-delta-value"
                      }, React.createElement(PreviewZonalOrClusterCampaignCmp$RenderArrowAndDeltaDetailsIcon, {
                            left_value: right_value,
                            right_value: active_mandatory_campaign.filters.allocation_radius.manual
                          })), radius_delta !== undefined ? React.createElement("div", {
                          className: "section-row"
                        }, React.createElement("p", {
                              className: "ald-zone-cluster-filter-type"
                            }, "Delta"), React.createElement("p", {
                              className: "ald-zone-cluster-filter-type-value"
                            }, String(radius_delta) + " KMS")) : null);
    case "Dry Run Ratio" :
        return React.createElement(React.Fragment, undefined, React.createElement("div", {
                        className: "section-row"
                      }, React.createElement("p", {
                            className: ""
                          }, subType, React.createElement(TooltipComponent$Catalyst.make, {
                                content: infoIconDescription,
                                placement: /* Top_End */10,
                                children: React.createElement("img", {
                                      className: "ald-zonal-cluster-item-info-icon-img",
                                      src: infoIcon
                                    })
                              }))), React.createElement("div", {
                        className: "section-row"
                      }, React.createElement("p", undefined, "Threshold"), React.createElement("p", undefined, String(left_value) + " KMS")), React.createElement("div", {
                        className: "section-row-delta-value"
                      }, React.createElement(PreviewZonalOrClusterCampaignCmp$RenderArrowAndDeltaDetailsIcon, {
                            left_value: left_value,
                            right_value: active_mandatory_campaign.filters.dry_run.threshold
                          })), React.createElement("div", {
                        className: "section-row"
                      }, React.createElement("p", undefined, "Ratio"), React.createElement("p", undefined, String(right_value))), React.createElement("div", {
                        className: "section-row-delta-value"
                      }, React.createElement(PreviewZonalOrClusterCampaignCmp$RenderArrowAndDeltaDetailsIcon, {
                            left_value: right_value,
                            right_value: active_mandatory_campaign.filters.dry_run.ratio
                          })), radius_delta !== undefined ? React.createElement("div", {
                          className: "section-row"
                        }, React.createElement("p", {
                              className: "ald-zone-cluster-filter-type"
                            }, "Delta"), React.createElement("p", {
                              className: "ald-zone-cluster-filter-type-value"
                            }, String(radius_delta) + " KMS")) : null);
    case "Max Dry Run" :
        return React.createElement(React.Fragment, undefined, React.createElement("div", {
                        className: "section-row"
                      }, React.createElement("p", {
                            className: ""
                          }, subType, React.createElement(TooltipComponent$Catalyst.make, {
                                content: infoIconDescription,
                                placement: /* Top_End */10,
                                children: React.createElement("img", {
                                      className: "ald-zonal-cluster-item-info-icon-img",
                                      src: infoIcon
                                    })
                              }))), React.createElement("div", {
                        className: "section-row"
                      }, React.createElement("p", undefined, "Auto"), React.createElement("p", undefined, String(left_value) + " KMS")), React.createElement("div", {
                        className: "section-row-delta-value"
                      }, React.createElement(PreviewZonalOrClusterCampaignCmp$RenderArrowAndDeltaDetailsIcon, {
                            left_value: left_value,
                            right_value: active_mandatory_campaign.filters.maps_distance.auto
                          })), React.createElement("div", {
                        className: "section-row"
                      }, React.createElement("p", undefined, "Manual"), React.createElement("p", undefined, String(right_value) + " KMS")), React.createElement("div", {
                        className: "section-row-delta-value"
                      }, React.createElement(PreviewZonalOrClusterCampaignCmp$RenderArrowAndDeltaDetailsIcon, {
                            left_value: right_value,
                            right_value: active_mandatory_campaign.filters.maps_distance.manual
                          })), radius_delta !== undefined ? React.createElement("div", {
                          className: "section-row"
                        }, React.createElement("p", {
                              className: "ald-zone-cluster-filter-type"
                            }, "Delta"), React.createElement("p", {
                              className: "ald-zone-cluster-filter-type-value"
                            }, String(radius_delta) + " KMS")) : null);
    default:
      return React.createElement(React.Fragment, undefined);
  }
}

var GetFilterType = {
  make: PreviewZonalOrClusterCampaignCmp$GetFilterType
};

function PreviewZonalOrClusterCampaignCmp(Props) {
  var active_mandatory_campaign = Props.active_mandatory_campaign;
  var form_data = Props.form_data;
  var setFormMode = Props.setFormMode;
  var onSubmit = Props.onSubmit;
  var zones = Props.zones;
  var clusters = Props.clusters;
  var preview_data = ZonalOrClusterCampaignPreviewVMMapper.VMMapper.getViewModel(form_data, zones, clusters);
  var tmp;
  if (Belt_Option.isSome(form_data.validations)) {
    var validations = form_data.validations;
    var tmp$1;
    if (validations !== undefined) {
      var validationsList = Belt_List.fromArray(Belt_Array.map(validations, (function (v) {
                  return [
                          v.validation_type,
                          v.segment_names
                        ];
                })));
      tmp$1 = React.createElement(PreviewZonalOrClusterCampaignCmp$GetSegmentNames, {
            validations: validationsList
          });
    } else {
      tmp$1 = null;
    }
    tmp = React.createElement("div", {
          className: "section"
        }, tmp$1);
  } else {
    tmp = null;
  }
  return React.createElement("div", {
              className: "c-preview-zonal-cluster-campaign"
            }, React.createElement("div", {
                  className: "section"
                }, React.createElement(PreviewZonalOrClusterCampaignCmp$GetCreatorInfo, {
                      created_by: preview_data.created_by,
                      created_on: preview_data.created_on,
                      status: undefined
                    })), React.createElement("div", {
                  className: "section"
                }, React.createElement(PreviewZonalOrClusterCampaignCmp$GetTimingDateAndActiveDaysInfo, {
                      type: preview_data._type,
                      startDate: preview_data.startDate,
                      startTime: preview_data.startTime,
                      endTime: preview_data.endTime,
                      endDate: preview_data.endDate,
                      days: preview_data.days
                    })), tmp, React.createElement("div", {
                  className: "section"
                }, React.createElement(PreviewZonalOrClusterCampaignCmp$GetListOfZonesOrClusters, {
                      preview_data: preview_data
                    })), React.createElement("div", {
                  className: "section"
                }, React.createElement(PreviewZonalOrClusterCampaignCmp$GetFilterType, {
                      subType: preview_data.subType,
                      infoIconDescription: preview_data.infoIconDescription,
                      left_value: preview_data.filter.left_value,
                      right_value: preview_data.filter.right_value,
                      radius_delta: preview_data.filter.radius_delta,
                      active_mandatory_campaign: active_mandatory_campaign
                    })), React.createElement(AllocationCampaignFooterCmp.make, {
                  onLeftBtnClick: (function (param) {
                      return Curry._1(setFormMode, (function (param) {
                                    return /* Edit */0;
                                  }));
                    }),
                  leftBtnText: "Back",
                  onRightBtnClick: (function (param) {
                      return Curry._1(onSubmit, undefined);
                    }),
                  rightBtnText: "Submit"
                }));
}

var make = PreviewZonalOrClusterCampaignCmp;

export {
  arrowDropDownRedIcon ,
  arrowDropDownGreenIcon ,
  infoIcon ,
  RenderArrowAndDeltaDetailsIcon ,
  GetCreatorInfo ,
  DisplaySection ,
  DisplayDateAndTimeSection ,
  GetTimingDateAndActiveDaysInfo ,
  GetSegmentNames ,
  GetListOfZones ,
  GetListOfZonesOrClusters ,
  GetFilterType ,
  make ,
  
}
/* arrowDropDownRedIcon Not a pure module */
